import {FC, Suspense} from 'react'
import {Route, Routes, Navigate, useLocation} from 'react-router-dom'
import {lazyWithRetry} from './lazyWithRetry'
import {MasterLayout} from '../../_myb/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {DashboardWrapperV2} from '../pages/dashboard/DashboardWrapperV2'
import {DashboardWrapperV3} from '../pages/dashboard/DashboardWrapperV3'
import {getCSSVariableValue} from '../../_myb/assets/ts/_utils'
import {WithChildren} from '../../_myb/helpers'
import RestrictedPage from '../modules/auth/components/RestrictedPage'
import LoadingPage from '../modules/auth/components/LoadingPage'



const PostLoginRedirect: FC = () => {
  const intendedUrl = sessionStorage.getItem('auth_intended_url') || '/dashboard'
  sessionStorage.removeItem('auth_intended_url')
  return <Navigate to={intendedUrl} replace />
}

const PrivateRoutes = () => {





  const ItemPage = lazyWithRetry(() => import('../modules/masterdata/ItemPage'))
  const ContactPage = lazyWithRetry(() => import('../modules/masterdata/ContactPage'))
  const TxnPage = lazyWithRetry(() => import('../modules/transactions/TxnPage'))
  const BankingPage = lazyWithRetry(() => import('../modules/banking/BankingPage'))
  const SettingsPage = lazyWithRetry(() => import('../modules/settings/SettingsPage'))
  const ReportPage = lazyWithRetry(() => import('../modules/reports/ReportPage'))
  const DocumentsPage = lazyWithRetry(() => import('../modules/documents/DocumentsPage'))
  const ManufacturingPage = lazyWithRetry(() => import('../modules/manufacturing/ManufacturingPage'))
  const ProjectsPage = lazyWithRetry(() => import('../modules/projects/ProjectsPage'))
  const BudgetPage = lazyWithRetry(() => import('../modules/budget/BudgetPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<PostLoginRedirect />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapperV3 />} />
        <Route path='dashboard-v1' element={<DashboardWrapper />} />
        <Route path='dashboard-v2' element={<DashboardWrapperV2 />} />
        {/* Old preview URL — keep resolving for anyone with it bookmarked */}
        <Route path='dashboard-v3' element={<Navigate to='/dashboard' replace />} />
        <Route path='no-access' element={<RestrictedPage />} />
        <Route path='loading' element={<LoadingPage />} />
        {/* Lazy Modules */}
        <Route
          path='items/*'
          element={
            <SuspensedView>
              <ItemPage />
            </SuspensedView>
          }
        />

        <Route
          path='contacts/*'
          element={
            <SuspensedView>
              <ContactPage />
            </SuspensedView>
          }
        />

        <Route
          path='banking/*'
          element={
            <SuspensedView>
              <BankingPage />
            </SuspensedView>
          }
        />

       <Route
          path='transactions/*'
          element={
            <SuspensedView>
              <TxnPage />
            </SuspensedView>
          }
        />
        <Route
          path='settings/*'
          element={
            <SuspensedView>
              <SettingsPage />
            </SuspensedView>
          }
        />

        <Route
          path='reports/*'
          element={
            <SuspensedView>
              <ReportPage />
            </SuspensedView>
          }
        />

        <Route
          path='documents/*'
          element={
            <SuspensedView>
              <DocumentsPage />
            </SuspensedView>
          }
        />


        <Route
          path='manufacturing/*'
          element={
            <SuspensedView>
              <ManufacturingPage />
            </SuspensedView>
          }
        />

        <Route
          path='projects/*'
          element={
            <SuspensedView>
              <ProjectsPage />
            </SuspensedView>
          }
        />

        <Route
          path='budgets/*'
          element={
            <SuspensedView>
              <BudgetPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
